import { MARQUEE } from "../../content/site";

export const Marquee = ({ items = MARQUEE }) => {
  const row = [...items, ...items];
  return (
    <div className="marquee overflow-hidden border-y border-[#74DC26]/20 bg-[#082619] py-6" data-testid="editorial-marquee" aria-label={items.join(", ")}>
      <div className="marquee-track flex w-max items-center gap-10 whitespace-nowrap" aria-hidden="true">
        {row.map((t, i) => (
          <span key={i} className="flex items-center gap-10">
            <span className={`font-display text-3xl md:text-5xl font-medium tracking-tight ${i % 2 ? "font-serif-i text-[#74DC26]" : "text-[#F9F8F3]"}`}>{t}</span>
            <span className="h-2.5 w-2.5 rotate-45 bg-[#74DC26]" />
          </span>
        ))}
      </div>
    </div>
  );
};
